var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTwitterX = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-x",
    transform: "translate(-2487 -6151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    width: 18,
    height: 18,
    transform: "translate(2487 6151)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M1.5.787H3.161l7.359,10.371H8.9ZM10.609,0,6.65,4.477,3.465,0H0L4.71,6.671,0,12H1L5.15,7.293,8.472,12H12l-4.911-6.9L11.583,0Z",
    transform: "translate(2490 6154.001)",
    fill: "#8d8d8d"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitterX, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitterX.ee572cc3.svg";
export { ForwardRef as ReactComponent };